import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box, fontSize } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import {
  BsCheck,
  BsCheckCircle,
  BsFile,
  BsFileBinary,
  BsFilePdf,
  BsUpload,
  BsXCircle,
} from "react-icons/bs";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import { useDispatch } from "react-redux";
import {
  notifyShowErrorMessage,
  notifyShowSuccessMessage,
} from "../../store/AlertSlice";
import { ErrorMessageResolver } from "../common/ErrorMessageResolver";
import ConfirmationDialog from "../common/ConfirmationDialog";

export const FinalDecisionForm = ({ appEntry, handleReloadAppEntry }) => {
  const [isPositiveDecision, setIsPositiveDecision] = useState(true);
  const [uploadedFinalDecisionFile, setUploadedFinalDecisionFile] =
    useState(null);
  const [generatedDocument, setGeneratedDocument] = useState(null);
  const [saving, setSaving] = useState(false);
  const [readyForFinalization, setReadyForFinalization] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState();
  const refFileInput = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(appEntry);
  }, [appEntry]);

  const download = (templateType) => {
    const link = document.createElement("a");
    link.href = `/docs/${templateType}`;
    link.download = templateType;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const submitFinalDoc = () => {
    setSaving(true);
    AppEntryRepository.uploadAndSignFinalDecision(
      appEntry.id,
      uploadedFinalDecisionFile
    )
      .then((response) => {
        console.log("Final decision uploaded and signed:", response.data);
        if (response.data) {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          setGeneratedDocument(pdfBlob);
          setReadyForFinalization(true);
          dispatch(
            notifyShowSuccessMessage(
              "Успешно е прикачен и генериран електронски печат и QR код на конечната одлука. Породолжете кон завршување на процесот."
            )
          );
        }
      })
      .catch((error) => {
        console.error("Error uploading final decision:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const finalizeAppEntry = () => {
    setSaving(true);
    AppEntryRepository.finalizeEntry(appEntry?.id, isPositiveDecision)
      .then((response) => {
        console.log("App entry finalized:", response.data);
        if (response.data) {
          dispatch(
            notifyShowSuccessMessage(
              "Успешно е завршен процесот на изработка на конечна одлука."
            )
          );
          handleReloadAppEntry();
        }
      })
      .catch((error) => {
        console.error("Error finalizing app entry:", error);
        dispatch(notifyShowErrorMessage(ErrorMessageResolver.resolve(error)));
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const previewFinalDoc = () => {
    if (generatedDocument) {
      const url = window.URL.createObjectURL(generatedDocument);
      window.open(url, "_blank");
      window.URL.revokeObjectURL(url);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Урнек</TableCell>
              <TableCell align="center">Преземи</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {appEntry?.type === "PERMANENT_TRAFFIC_CHANGE" && (
              <>
                <TableRow>
                  <TableCell>
                    <BsCheckCircle
                      style={{
                        fontSize: "20px",
                        verticalAlign: "middle",
                        color: "green",
                      }}
                    />{" "}
                    <Typography
                      variant="body1"
                      component="span"
                      style={{ verticalAlign: "middle" }}
                    >
                      Решение за траен режим на сообраќај
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      size="small"
                      style={{ fontSize: "12px", lineHeight: "1.0" }}
                      onClick={() => {
                        download("Решение за траен режим на сообраќај.docx");
                      }}
                    >
                      Преземи .docx
                    </Button>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <BsXCircle
                      style={{
                        fontSize: "20px",
                        verticalAlign: "middle",
                        color: "red",
                      }}
                    />{" "}
                    <Typography
                      variant="body1"
                      component="span"
                      style={{ verticalAlign: "middle" }}
                    >
                      Решение за одбивање на барање за траен режим на сообраќај
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      size="small"
                      style={{ fontSize: "12px", lineHeight: "1.0" }}
                      onClick={() => {
                        download(
                          "Решение за одбивање на барање за траен режим на сообраќај.docx"
                        );
                      }}
                    >
                      Преземи .docx
                    </Button>
                  </TableCell>
                </TableRow>
              </>
            )}
            {appEntry?.type === "TEMPORARY_TRAFFIC_CHANGE" && (
              <>
                <TableRow>
                  <TableCell>Одобрение за времен режим на сообраќај</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      size="small"
                      style={{ fontSize: "12px", lineHeight: "1.0" }}
                      onClick={() => {
                        download("Одобрение за времен режим на сообраќај.docx");
                      }}
                    >
                      Преземи .docx
                    </Button>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    Решение за одбивање на барање за времен режим
                  </TableCell>
                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      size="small"
                      style={{ fontSize: "12px", lineHeight: "1.0" }}
                      onClick={() => {
                        download(
                          "Решение за одбивање на барање за времен режим.docx"
                        );
                      }}
                    >
                      Преземи .docx
                    </Button>
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12} md={7}>
        <Typography variant="h6" gutterBottom>
          &nbsp;
        </Typography>
        <Alert severity="warning" variant="outlined">
          Чекор 1. Најпрво е потребно да го преземете соодветниот урнек на
          конечна одлука од табелата лево.
          <br />
          Чекор 2. Пополнете ги потребните информации во документот и зачувајте
          го во PDF формат.
          <br />
          Чекор 3. Во системот прикачете го документот во соодветното поле
          подолу. Со тоа ќе го завршите процесот на изработка на конечна
          одлука/решение на кое ќе се стави електронски печат и QR код за
          верификација.
        </Alert>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="center" sx={{ p: 2 }}>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              color="gutterBottom"
              sx={{ mb: -1, mt: 2 }}
            >
              Прикачи документ
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            <input
              type="file"
              accept="application/pdf"
              style={{ display: "none" }}
              ref={refFileInput}
              onChange={(e) => {
                if (e.target.files.length > 0) {
                  const file = e.target.files[0];
                  setUploadedFinalDecisionFile(file);
                }
              }}
            />
            <Button
              variant="contained"
              fullWidth
              color="primary"
              size="medium"
              startIcon={<BsUpload />}
              onClick={() => refFileInput.current.click()}
            >
              Избери датотека
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            {uploadedFinalDecisionFile && (
              <Typography variant="body1" style={{ marginLeft: "16px" }}>
                Селектирана датотека: <BsFilePdf size={24} color="#af3939" />
                <b>{uploadedFinalDecisionFile.name}</b>
              </Typography>
            )}
          </Grid>
          {uploadedFinalDecisionFile && (
            <>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="h6"
                  color="gutterBottom"
                  sx={{ mb: 1, mt: 2 }}
                >
                  Дали одлуката е позитивна или негативна?
                </Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Button
                    variant={isPositiveDecision ? "contained" : "outlined"}
                    color="success"
                    onClick={() => setIsPositiveDecision(true)}
                  >
                    Позитивна
                  </Button>
                  <Button
                    variant={!isPositiveDecision ? "contained" : "outlined"}
                    color="error"
                    onClick={() => setIsPositiveDecision(false)}
                  >
                    Негативна
                  </Button>
                </Box>
              </Grid>
              {!readyForFinalization && (
                <Grid item xs={12} md={12}>
                  <Typography
                    variant="h6"
                    color="gutterBottom"
                    sx={{ mb: 1, mt: 2 }}
                  >
                    Генерирај QR код и електронски печат
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={saving}
                    size="large"
                    onClick={() => {
                      submitFinalDoc();
                    }}
                  >
                    Генерирај
                  </Button>
                </Grid>
              )}
            </>
          )}
          {readyForFinalization && (
            <Grid item xs={12} md={12}>
              <Typography
                variant="h6"
                color="gutterBottom"
                sx={{ mb: 1, mt: 2 }}
              >
                Потврди и испрати
              </Typography>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  onClick={() => previewFinalDoc()}
                  variant="outlined"
                  startIcon={<BsFilePdf />}
                  color="secondary"
                >
                  Прегледај финален документ
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  disabled={saving}
                  startIcon={<BsCheck />}
                  onClick={() => {
                    setOpenConfirmationDialog({
                      onConfirm: () => {
                        finalizeAppEntry();
                        setOpenConfirmationDialog();
                      },
                      title: "Потврда за завршување на процесот",
                      message: `Дали сте сигурни дека сакате да го завршите процесот на изработка на конечна одлука со испраќање на ${
                        isPositiveDecision ? "позитивна" : "негативна"
                      } одлука?`,
                    });
                  }}
                >
                  Потврди и испрати одлука
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
      {saving && (
        <Backdrop open={saving} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {openConfirmationDialog && (
        <ConfirmationDialog
          open={Boolean(openConfirmationDialog)}
          title={openConfirmationDialog.title}
          message={openConfirmationDialog.message}
          onCancel={() => setOpenConfirmationDialog()}
          onConfirm={openConfirmationDialog.onConfirm}
        />
      )}
    </Grid>
  );
};
